import React from "react";

// Shows the selected variation (Colour / Size ...) below the product name,
// in the cart page, the cart sidebar and the mini cart.
const CartVariationInfo = ({ cartItem, style }) => {
  const attributes = (cartItem?.VariationAttributes || []).filter(
    (attr) => attr && attr.value
  );
  const variationName = cartItem?.VariationName;

  if (attributes.length === 0 && !variationName) return null;

  return (
    <p className="cart_variation_info" style={style}>
      {attributes.length > 0 ? (
        attributes.map((attr, i) => (
          <span className="sm-txt" key={i}>
            {attr.name ? `${attr.name}: ` : ""}
            {attr.value}{" "}
          </span>
        ))
      ) : (
        <span className="sm-txt">{variationName}</span>
      )}
    </p>
  );
};

export default CartVariationInfo;
